import { newId } from '@tahi/core';
import type { LocalDb } from './localDb';
import { getState, setState } from './syncState';

const KEY = 'device_id';

/** Reserved by the Worker for its own changes (its SERVER_DEVICE_ID); a push or pull with it gets 400. */
export const SERVER_DEVICE_ID = 'server';

/**
 * The sync device id, stored in this local database's sync_state. The server leaves a device's
 * own changes out of its pulls, so the id must live and die with the database: after sign-out
 * wipes the file (or in memory mode, on every load) a new id makes the first pull complete.
 * Never 'server': a stored 'server' is replaced, and a new id is checked before it is saved.
 */
export async function getDeviceId(db: LocalDb): Promise<string> {
  const existing = await getState(db, KEY);
  if (existing && existing !== SERVER_DEVICE_ID) return existing;
  const id = newId();
  if (id === SERVER_DEVICE_ID) throw new Error(`Device id must not be '${SERVER_DEVICE_ID}'`);
  await setState(db, KEY, id);
  return id;
}
